if (!customElements.get('free-shipping-bar')) {
  class FreeShippingBar extends HTMLElement {
    static lastProgress = null;

    connectedCallback() {
      const fill = this.querySelector('[data-free-shipping-fill]');
      if (!fill) return;

      const target = Number(this.dataset.freeShippingProgress);
      const progress = Number.isFinite(target) ? Math.max(0, Math.min(100, target)) : 0;
      const previous = FreeShippingBar.lastProgress;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const shouldAnimate = !reduceMotion && previous !== null && previous !== progress;

      fill.style.transition = 'none';
      fill.style.width = `${shouldAnimate ? previous : progress}%`;

      if (!shouldAnimate) {
        FreeShippingBar.lastProgress = progress;
        return;
      }

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          fill.style.transition = '';
          fill.style.width = `${progress}%`;
        });
      });

      FreeShippingBar.lastProgress = progress;
    }
  }

  customElements.define('free-shipping-bar', FreeShippingBar);
}
